import Consensi from "../";

const routes = [
      { name: "Consensi", path: "/consensi", component: Consensi.ConsensiListPage, meta: { title: "Lista Consensi" } },
      { name: "Consensi", path: "/consensi/edit/:id", component: Consensi.ConsensiEditPage, meta: { title: "Crea/Modifica Consensi" } },
      { name: "Consensi", path: "/consensi/view/:id", component: Consensi.ConsensiViewPage, meta: { title: "Visualizza Consensi" } },


];

export default routes;